export function completeLoginSession(tokens, context, history) {
    const {access, refresh, role} = tokens || {};
    if (![access, refresh, role].every((value) => typeof value === 'string' && value.length > 0)) {
        return Promise.reject(new Error('Invalid authentication payload'));
    }
    context.handleWorkspace([]);
    localStorage.setItem('token', access);
    localStorage.setItem('refreshToken', refresh);
    localStorage.setItem('role', role);
    const callbackUrl = context.handleCallbackUrl() || sessionStorage.getItem('authCallbackUrl');
    if (callbackUrl && callbackUrl !== '/') {
        sessionStorage.removeItem('authCallbackUrl');
        context.handleCallbackUrl('/');
        history.replace(callbackUrl);
    } else {
        history.replace('/dashboard/workspace');
    }
    return Promise.resolve();
}
